// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Buttons from './../pages/Buttons'
import router from '../router'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#buttons',
  router,
  template: '<Buttons/>',
  components: { Buttons }
})



// WEBPACK FOOTER //
// ./src/js/buttons.js